export const certification = [
    {
        name: 'Data Science Course',
        organization: 'BrainStation',
        year: '2023',
        credentialLink: 'https://brainstation.io/documents/certificates/830-935-954',

    },
    {
        name: 'Front-end Development Course',
        organization: 'Facebook/Coursera',
        year: '2023',
        credentialLink: 'https://www.coursera.org/account/accomplishments/certificate/JRX7L4FQSSPG',
    },
]